/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.ItemButterflyDropdownFilter = (function() {

    /**
     * Namespace ItemButterflyDropdownFilter.
     * @exports ItemButterflyDropdownFilter
     * @namespace
     */
    var ItemButterflyDropdownFilter = {};

    ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel = (function() {

        /**
         * Properties of an ItemButterflyDropdownFilterModel.
         * @memberof ItemButterflyDropdownFilter
         * @interface IItemButterflyDropdownFilterModel
         * @property {string|null} [butterflyCode] ItemButterflyDropdownFilterModel butterflyCode
         * @property {string|null} [description] ItemButterflyDropdownFilterModel description
         * @property {number|null} [pageIndex] ItemButterflyDropdownFilterModel pageIndex
         * @property {number|null} [pageSize] ItemButterflyDropdownFilterModel pageSize
         */

        /**
         * Constructs a new ItemButterflyDropdownFilterModel.
         * @memberof ItemButterflyDropdownFilter
         * @classdesc Represents an ItemButterflyDropdownFilterModel.
         * @implements IItemButterflyDropdownFilterModel
         * @constructor
         * @param {ItemButterflyDropdownFilter.IItemButterflyDropdownFilterModel=} [p] Properties to set
         */
        function ItemButterflyDropdownFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ItemButterflyDropdownFilterModel butterflyCode.
         * @member {string|null|undefined} butterflyCode
         * @memberof ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel
         * @instance
         */
        ItemButterflyDropdownFilterModel.prototype.butterflyCode = null;

        /**
         * ItemButterflyDropdownFilterModel description.
         * @member {string|null|undefined} description
         * @memberof ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel
         * @instance
         */
        ItemButterflyDropdownFilterModel.prototype.description = null;

        /**
         * ItemButterflyDropdownFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel
         * @instance
         */
        ItemButterflyDropdownFilterModel.prototype.pageIndex = null;

        /**
         * ItemButterflyDropdownFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel
         * @instance
         */
        ItemButterflyDropdownFilterModel.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * ItemButterflyDropdownFilterModel _butterflyCode.
         * @member {"butterflyCode"|undefined} _butterflyCode
         * @memberof ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel
         * @instance
         */
        Object.defineProperty(ItemButterflyDropdownFilterModel.prototype, "_butterflyCode", {
            get: $util.oneOfGetter($oneOfFields = ["butterflyCode"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * ItemButterflyDropdownFilterModel _description.
         * @member {"description"|undefined} _description
         * @memberof ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel
         * @instance
         */
        Object.defineProperty(ItemButterflyDropdownFilterModel.prototype, "_description", {
            get: $util.oneOfGetter($oneOfFields = ["description"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * ItemButterflyDropdownFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel
         * @instance
         */
        Object.defineProperty(ItemButterflyDropdownFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * ItemButterflyDropdownFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel
         * @instance
         */
        Object.defineProperty(ItemButterflyDropdownFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified ItemButterflyDropdownFilterModel message. Does not implicitly {@link ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel.verify|verify} messages.
         * @function encode
         * @memberof ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel
         * @static
         * @param {ItemButterflyDropdownFilter.IItemButterflyDropdownFilterModel} m ItemButterflyDropdownFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ItemButterflyDropdownFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.butterflyCode != null && Object.hasOwnProperty.call(m, "butterflyCode"))
                w.uint32(10).string(m.butterflyCode);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(18).string(m.description);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(24).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(32).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified ItemButterflyDropdownFilterModel message, length delimited. Does not implicitly {@link ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel
         * @static
         * @param {ItemButterflyDropdownFilter.IItemButterflyDropdownFilterModel} message ItemButterflyDropdownFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ItemButterflyDropdownFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ItemButterflyDropdownFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel} ItemButterflyDropdownFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ItemButterflyDropdownFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.butterflyCode = r.string();
                    break;
                case 2:
                    m.description = r.string();
                    break;
                case 3:
                    m.pageIndex = r.int32();
                    break;
                case 4:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes an ItemButterflyDropdownFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ItemButterflyDropdownFilter.ItemButterflyDropdownFilterModel} ItemButterflyDropdownFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ItemButterflyDropdownFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return ItemButterflyDropdownFilterModel;
    })();

    return ItemButterflyDropdownFilter;
})();

module.exports = $root;
